// extracted by mini-css-extract-plugin
export var backlinkPresent = "style-module--backlink-present--8bee3";
export var scrolled = "style-module--scrolled--e8ca5";
export var shareList = "style-module--share-list--28fab";
export var textWithIcon = "style-module--text-with-icon--c8e28";
export var timeAndDateWrapper = "style-module--time-and-date-wrapper--17d4f";
export var wrapper = "style-module--wrapper--aa08e";